import Breadcrumbs from "../Breadcrumbs";
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
const Sidebar = () => {
    const obj = [
        {id: 1, number: 500,
         text: 'Bought'},
         {id: 2, number: 32,
         text: 'Wishlist'},
         {id: 3, number: 1100,
         text: 'Following'}
    ];
    const details = [
        {id: 1, header: "Email address",
         text: 'mark.example@gmail.com'},
         {id: 2, header: "Phone number",
         text: '+234 75 4324 6464'},
         {id: 3, header: "Birthday",
         text: 'Dec 11th, 2025'}
    ];
    return (
        <div className=" lg:w-[22.5vw] h-[40vh] lg:mb-0 mb-12 lg:h-[95vh]">
            <div className="flex flex-col items-center pt-8 pb-12 ">
              <img className="h-32 w-32 border border-slate-300 rounded-xl" src='https://img.freepik.com/premium-vector/young-black-man-face-with-beard-male-portrait-avatar-flat-style-front-view_497399-251.jpg?w=2000'/>
              <h1 className="mt-6 text-2xl text-slate-700">Mark Deo</h1>
              <p className=" font-thin text-slate-400">markdeo2222@gmail.com</p>
              <button className="bg-orange-500 hover:bg-orange-700 rounded-lg mt-6 text-white font-bold py-2 px-4">Follow</button>
              <div className="flex flex-row mt-6 ml-4">
               {obj.map((items) => (
                <div className="flex flex-col mx-10 items-center" key={items.id}>

                <h1 className="text-slate-600 font-medium">{items.number}</h1>
                  <p className="font-thin text-slate-400">{items.text}</p>
                </div>
      ))}
              </div>
            </div>
            <div className=" ml-9 mt-2 pt-12" style={{
                borderTop: '1px solid red'
            }}>
                <h1 className="text-2xl text-slate-700">Contact Information</h1>
                <div className="mt-6">
                    {details.map((objects) => (
                    <div className="mt-4" key={objects.id}>
                        <h3 className="text-slate-600 font-medium">{objects.header}</h3>
                        <p className="font-thin text-slate-400">{objects.text}</p>
                    </div>
                ))}
                </div>
                
                <h3 className="mt-6 text-slate-700">Social Profile</h3>
                <div className="flex flex-row mt-4">
                    <TwitterIcon className="stroke-orange-500" style={{
                        color: 'white'
                    }}/>
                    <FacebookIcon className="ml-2 stroke-orange-500" style={{
                        color: 'white'
                    }}/>
                    <LinkedInIcon className="ml-2 stroke-orange-500" style={{
                        color: 'white'
                    }}/>
                    <InstagramIcon className="ml-2 stroke-orange-500" style={{
                        color: 'white'
                    }}/>
                </div>

            </div>
        </div>
    )
}

export default Sidebar;